// Polyfill for container queries
// https://caniuse.com/?search=%40container
// https://codepen.io/chriscoyier/pen/yLzKavz
//
const supportsContainerQueries = "container" in document.documentElement.style;

if(!supportsContainerQueries) {
  import("container-query-polyfill")
}
